import React, {useContext} from 'react';
import {SidebarContext} from "../../../../../../SidebarContext";

import ApplicationButton from "../ApplicationButton";

import {APPLICATIONS as Apps} from "utils/Applications";

function StripeItem(props) {
    const {stripeLink} = useContext(SidebarContext);

    if (!stripeLink) {
        return null;
    }

    return (
        <ApplicationButton
            application={Apps.STRIPE}
            selected={false}
            onClick={() => window.open(stripeLink, '_blank')}
        />
    );
}

export default StripeItem;
